module.exports = __webpack_public_path__ + "static/img/img_IPmin_2.4ac3a34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/img_IPmin_2.png
// module id = ByzR
// module chunks = 0